import React, { useContext } from 'react';
import { useDeleteQuizMutation } from '../../services/SkillsManagement';
import { useDispatch } from 'react-redux';
import { DELETE_QUIZ } from '../../Reducers/Actions';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';
import MuiDialog from '../../SystemDesign/MuiDialog';

// Simple delete dialog for quizzes, inspired by Administration/Postes/DeletePoste.jsx
const DeleteQuiz = ({ row }) => {
  const [deleteQuiz, { isLoading }] = useDeleteQuizMutation();
  const dispatch = useDispatch();
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);

  const quiz = row?.original || {};

  if (!quiz || !('quizId' in quiz)) return null;

  const handleDelete = async () => {
    try {
      try {
        const response = await deleteQuiz({ id: Number(quiz.quizId) }).unwrap();

        // Update Redux store after successful API call
        dispatch({ type: DELETE_QUIZ, quizId: quiz.quizId });

        // Extract success message if present
        let successMessage;
        if (typeof response === 'string') {
          successMessage = response;
        } else if (response && typeof response === 'object' && response.message) {
          successMessage = response.message;
        } else {
          successMessage = `Quiz "${quiz.title || 'Unknown'}" deleted successfully`;
        }

        setInfoAlert({ severity: 'success', message: successMessage });
        setOpenSnackBar(true);

        return true;
      } catch (parseError) {
        // Handle plain-text 200 responses
        if (parseError?.originalStatus === 200) {
          dispatch({ type: DELETE_QUIZ, quizId: quiz.quizId });

          const successMessage = parseError.data || `Quiz "${quiz.title || 'Unknown'}" deleted successfully`;
          setInfoAlert({ severity: 'success', message: successMessage });
          setOpenSnackBar(true);
          return true;
        }
        throw parseError;
      }
    } catch (error) {
      console.error('Error deleting quiz:', error);
      let errorMessage = 'An error occurred while deleting the quiz';
      if (error?.data?.message) {
        errorMessage = typeof error.data.message === 'string' ? error.data.message : JSON.stringify(error.data.message);
      } else if (error?.message) {
        errorMessage = error.message;
      }
      setInfoAlert({ severity: 'error', message: errorMessage });
      setOpenSnackBar(true);
      return false;
    }
  };

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <DeleteIcon fontSize="small" color="error" />
      </ListItemIcon>
      <ListItemText>Delete</ListItemText>
    </MenuItem>
  );

  const dialogContent = (
    <div>
      <p>Are you sure you want to delete {quiz.title} ?</p>
      <p>This action is irreversible</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<DeleteOutlineIcon />}
      triggerButton={triggerButton}
      title="Delete"
      subtitle={`You are about to delete ${quiz.title}`}
      content={dialogContent}
      maxWidth="xs"
      existAction={true}
      actionTitle="Delete"
      actionFunction={handleDelete}
      isLoading={isLoading}
    />
  );
};

// Add static properties for menu integration
DeleteQuiz.menuIcon = <DeleteOutlineIcon fontSize="small" />;
DeleteQuiz.menuLabel = 'Delete';

export default DeleteQuiz;

